import api from "../../../api"

export function manageComponents(page, keyword, active){
    return api.get(`cms/components?${keyword}${active}pageSize=10&pageNumber=${page}`);
}

export function allSegment(){
    return api.get("cms/segments/all");
}

export function allContent(){
    return api.get("cms/contents/all")
}

export function oneComponentDetail(id){
    return api.get(`cms/components/${id}`);
}

export function putEditComponent(id, payload){
    return api.put(`cms/components/${id}`, payload)
}

export function viewTypeData(id, type){
    return api.get(`cms/components/${id}/component-${type}`);
}

export function activeStatus(id, type){
    return api.put(`cms/components/${id}/status?isActive=${type}`);
}
